import { Component, OnInit } from '@angular/core';
import { Review, ReviewsResponse, ReviewFilters, COMPANY_ASSOCIATED } from 'voxloud-types/dist/models/reviews';
import { ReviewsService } from 'src/app/domains/reviews/services';

@Component({
  selector: 'gdp-reviews-main',
  templateUrl: './reviews-main.component.html',
  styleUrls: ['./reviews-main.component.scss']
})
export class ReviewsMainComponent implements OnInit {
  public reviews: Review[] | null = null;
  public pageSize: number = 10;
  public page: number = 0;
  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };
  public filters: ReviewFilters;
  public sameFilters: boolean = true;
  public loading = false;
  constructor(
    private reviewsService: ReviewsService
  ) {
    this.filters = {
      company_id: null,
      is_company_associated: COMPANY_ASSOCIATED[1],
      timestamp_from: null,
      timestamp_to: null,
      platform: null,
      rating_from: null,
      rating_to: null
    }
  }

  ngOnInit(): void {
    this.getAllReviews();
  }

  getAllReviews() {
    this.reviews = [];
    this.loading = true;
    if (this.filters && !this.sameFilters) {
      this.pagination.page = 0;
    } else {
      this.pagination.page = this.pagination.page;
    }
    this.sameFilters = true;
    this.loading = true;
    this.reviewsService.getAllReviews(
      this.pagination.page,
      this.pageSize,
      this.filters
    ).subscribe((response: ReviewsResponse) => {
      this.reviews = response.content;
      this.pagination = {
        page: response.pageable.pageNumber,
        empty: response.empty,
        totalPages: response.totalPages
      };
      this.loading = false;
    });
  }


  get loadingLinesArray() {
    return new Array(this.pageSize);
  }

  filterChanged(event: ReviewFilters) {
    if (this.areNotEmptyFilters(event)) {
      this.filters = event;
    } else {
      this.filters = null;
    }
    this.sameFilters = false;
    this.getAllReviews();
  }

  areNotEmptyFilters(event) {
    return event.company_id !== '' ||
      event.is_company_associated !== '' ||
      event.timestamp_from !== '' ||
      event.timestamp_to !== '' ||
      event.platform !== '' ||
      event.rating_from !== '' ||
      event.rating_to !== ''
  }

  selectPageSize(event: number) {
    this.pageSize = event;
    this.pagination.page = 0;
    this.getAllReviews();
  }

  changeCurrentPage(event: number) {
    this.pagination = {
      ...this.pagination,
      page: event,
    }
    this.getAllReviews();
  }

  onReviewChanged() {
    this.getAllReviews();
  }
}
